import {useEffect, useState} from 'react';
import {Trans} from '@common/i18n/trans';
import { Button } from '@common/ui/buttons/button';
import { useAuth } from '@common/auth/use-auth';
import { useLoanProgramAction } from './requests/use-check-loan-program-action';

type ExecuteLoanProgramActionProps = {
  loan_product_id: number;
  meta_header: string
  uploadedFileItem: any,
};
export function LoanProgramAction( {loan_product_id, meta_header, uploadedFileItem}: ExecuteLoanProgramActionProps) {
  
  const files = uploadedFileItem ? uploadedFileItem : [];
  const {user} = useAuth();

  const [fileName, setFileName] = useState('');
  useEffect(() => {
    if (uploadedFileItem.name) {
      setFileName(uploadedFileItem.name);
    } else if (uploadedFileItem.filename) {
      setFileName(uploadedFileItem.filename);
    }
  }, [uploadedFileItem]);

  const executeLoanProgramAction = useLoanProgramAction(loan_product_id, meta_header, files);
  return (
    <>
      <Button
        size={'xs'} variant="flat" color="orange"
        type="submit"
        onClick={() => {
          executeLoanProgramAction.mutate(
            {loan_product_id: loan_product_id, meta_header: meta_header, files: files},
            {
              onSuccess: (response) => {
                //onProcess(response.status, response.total_files, response.uploaded_date, response.file_name);
              },

            },
          );
        }}
        disabled={!fileName || executeLoanProgramAction.isPending}
        >
        <Trans message={`Upload Loan Program`} />
      </Button>
    </>

  );
}
